<template lang="pug">
#teams
  div(v-if="!teamsVisible && !showDialogLoading")
    AppUpsellBanner(
      :feature="teamsFeature"
      :organization-id="organizationId"
      :can-manage-billing="canManageBilling"
    )
  div(v-else)
    ValidationProvider(
      v-slot="{ errors }"
      :rules="requiredField"
      name="teams"
      :model-value="selectedTeams"
    )
      .form-group(:class="{ 'has-error': errors[0] }")
        label.control-label Teams
        a.pull-right.select-all(
          v-if="teamsOptions.length"
          @click="selectAll"
        )
          | Select all
        AppSelect(
          :value="selectedTeams"
          :options="teamsOptions"
          :select2-options="select2Options"
          :disabled="!teamsEnabled"
          @input="updateTeams($event)"
        )
        AppDialogError(:errors="errors")
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { mapFormFields } from '~/utils/form_utils';

export default {
  name: 'ProjectDialogTabTeams',
  data() {
    return {
      defaultSelect2Options: {
        allowClear: true,
        multiple: true,
        width: '100%',
      },
    };
  },
  computed: {
    ...mapState({
      organization: 'organization',
      project: 'project',
      teams: 'teams',
      users: 'users',
      organizationId: (state) => state.organization.id,
      selectedTeams: (state) => state.project.team_ids || [],
    }),
    ...mapFormFields('project', {
      linkToTasks: 'link_to_task',
    }),
    ...mapGetters([
      'teamsFeature',
      'teamsEnabled',
      'teamsVisible',
      'teamRequired',
      'canManageTeams',
      'canManageBilling',
      'showDialogLoading',
    ]),
    teamsOptions() {
      let options = [];
      const teams = this.teams;
      const teamFilter = (team) => {
        if (!this.hasTeamsSyncFlag) {
          return true;
        }

        // When new project is going to be linked, we need to show only linked teams
        if (this.linkToTasks && !this.project.id) {
          return Number.isInteger(team.sync_version);
        }

        // Show only linked teams when project is linked
        if (Number.isInteger(this.project.sync_version)) {
          // Keep linked and already selected teams
          return (
            Number.isInteger(team.sync_version) || this.selectedTeams.map((id) => parseInt(id, 10)).includes(team.id)
          );
        }

        return true;
      };

      if (teams && teams.length) {
        options = teams
          .filter(teamFilter)
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((team) => ({
            id: team.id,
            text: `${team.name} (${team.members.length})`,
            type: 'team',
            hint: this.teamMemberNames(team.members),
          }));
      }

      return options;
    },
    requiredField() {
      return this.teamRequired && this.teamsOptions.length && this.canManageTeams ? 'required' : '';
    },
    select2Options() {
      return {
        ...this.defaultSelect2Options,
        ...{
          placeholder: 'Select teams',
        },
      };
    },
    hasTeamsSyncFlag() {
      return this.organization.flags.includes('teams_sync');
    },
  },
  methods: {
    ...mapActions(['updateTeams']),
    selectAll() {
      const val = this.teamsOptions.map(({ id }) => id);

      this.updateTeams(val);
    },
    teamMemberNames(members) {
      if (members.length && this.users && this.users.length) {
        return this.users
          .filter((user) => members.map((member) => member.user_id).includes(user.id))
          .map((tm) => tm.name)
          .join(', ');
      }
      if (!members.length) {
        return 'No team members';
      }
    },
  },
};
</script>
